// src/services/testApi.ts
import { api } from "@/services/api";

export interface TestType {
  id: number;
  testName: string;
  testDescription: string;
  testCategory: string;
  testComponents?: string; // JSON array string
  status: "ACTIVE" | "INACTIVE";
  createdAt: string;
  updatedAt: string;
  createdBy: string;
  updatedBy: string;
}

export interface TestTypeRequest {
  testName: string;
  testDescription: string;
  testCategory: string;
  status: "ACTIVE" | "INACTIVE";
}

export const testApi = api.injectEndpoints({
  endpoints: (builder) => ({
    // Get all test types
    listTestTypes: builder.query<TestType[], void>({
      query: () => `/super-admin/tests`,
      providesTags: ["Tests"],
    }),

    // Create test type - Send camelCase to backend
    createTestType: builder.mutation<TestType, TestTypeRequest>({
      query: (data) => {
        // Ensure data is in camelCase
        const payload = {
          testName: data.testName,
          testCategory: data.testCategory,
          testDescription: data.testDescription,
          status: data.status,
        };

        return {
          url: `/super-admin/tests`,
          method: "POST",
          body: payload,
        };
      },
      invalidatesTags: ["Tests"],
    }),

    // Update test type - Send camelCase to backend
    updateTestType: builder.mutation<
      TestType,
      { id: number; data: Partial<TestTypeRequest> }
    >({
      query: ({ id, data }) => {
        // Ensure data is in camelCase
        const payload = {
          testName: data.testName,
          testCategory: data.testCategory,
          testDescription: data.testDescription,
          status: data.status,
        };

        return {
          url: `/super-admin/tests/${id}`,
          method: "PUT",
          body: payload,
        };
      },
      invalidatesTags: ["Tests"],
    }),

    // Delete test type
    deleteTestType: builder.mutation<{ message: string }, number>({
      query: (id) => ({
        url: `/super-admin/tests/${id}`,
        method: "DELETE",
      }),
      invalidatesTags: ["Tests"],
    }),

    // Get test type by ID
    getTestTypeById: builder.query<TestType, number>({
      query: (id) => `/super-admin/tests/${id}`,
      providesTags: ["Tests"],
    }),
  }),
});

export const {
  useListTestTypesQuery,
  useCreateTestTypeMutation,
  useUpdateTestTypeMutation,
  useDeleteTestTypeMutation,
  useGetTestTypeByIdQuery,
} = testApi;
